/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { INotificationSettings } from "@/interfaces";
import dayjs from "dayjs";
import { BigNumber as ethersBigNumber, ethers } from "ethers";
import { enqueueSnackbar } from "notistack";
import numeral from "numeral";
import Cookies from "js-cookie";
import jwtDecode from "jwt-decode";
export function formatDateTime(input: string | number): string {
  if (!input || input === "undefined") return "-";

  if (dayjs(input).isValid()) {
    return dayjs(input).format("DD MMMM YYYY - HH:MM:ss");
  }

  return "-";
}

export function deleteNullUndefinedFields(obj: any) {
  // Get all entries of the object
  const entries = Object.entries(obj);

  // Filter out entries with null or undefined values
  const filteredEntries = entries.filter(
    ([key, value]) => value !== null && value !== undefined,
  );

  // Convert the filtered entries back to an object
  const newObj = Object.fromEntries(filteredEntries);

  return newObj;
}

export function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

export function stringAvatar(name: string, sx?: any) {
  const words = name.split(" ");
  let children = "";

  if (words.length === 1) {
    children = words[0][0];
  } else if (words.length > 1) {
    children = `${words[0][0]}${words[1][0]}`;
  }

  return {
    sx: {
      bgcolor: stringToColor(name),
      ...sx,
    },
    children,
  };
}

export const authToken = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const user = localStorage.getItem("user") as any;
  const accessToken = Cookies.get("x-access-token");
  let tokenIsValid = false;
  if (accessToken) {
    try {
      const decoded = jwtDecode(accessToken || "") as any;
      if (decoded.exp * 1000 < Date.now()) {
        Cookies.remove("x-access-token");
        tokenIsValid = false;
      } else {
        tokenIsValid = true;
      }
    } catch (err) {
      Cookies.remove("x-access-token");
    }
  }
  if (tokenIsValid) {
    return {
      authorization: `Bearer ${accessToken}`,
    };
  } else {
    return {
      authorization: null,
    };
  }
};
export const formatedBigNumber = (value: ethersBigNumber | string): string => {
  if (typeof value === "string") {
    value = ethers.utils.parseUnits(value, "wei");
  }

  if (value.gte(ethers.utils.parseEther("1000"))) {
    const SplitEtherValue = ethers.utils.formatEther(value).split(".");

    const integerValue = SplitEtherValue[0];
    const decimalValue = SplitEtherValue[1];
    const formatedIntegerValue = numeral(integerValue).format("0,0");
    const result = formatedIntegerValue + "." + decimalValue;

    return result;
  } else {
    return ethers.utils.formatEther(value);
  }
};

export function containsAnyString(strings: string[], target: string): boolean {
  for (let i = 0; i < strings.length; i++) {
    if (target.includes(strings[i])) {
      return true;
    }
  }
  return false;
}

// only display notifications
function displayNotification(settings: INotificationSettings) {
  const options = {
    body: settings.body,
    icon: settings.icon,
  };

  const notification = new Notification(settings.title, options);

  notification.onclick = () => {
    if (settings.path) {
      window.location.href = settings.path;
    }
    notification.close();
  };
}

// only request notifications
export const requestNotificationPermission = async (): Promise<boolean> => {
  if (!("Notification" in window)) {
    console.error("This browser does not support notifications.");
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  enqueueSnackbar(
    "Please grant permission to receive notifications for new orders and messages.",
    {
      variant: "info",
      preventDuplicate: true,
    },
  );

  return Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      return true;
    } else if (permission === "denied") {
      enqueueSnackbar("Notification permission denied", {
        variant: "error",
        preventDuplicate: true,
      });
    }
    return false;
  });
};

// request and display notifications
export const showNotification = async (settings: INotificationSettings) => {
  if (await requestNotificationPermission()) {
    displayNotification(settings);
  }
};
export function copyToClipboard(textToCopy: string) {
  // navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
    // navigator clipboard api method'
    return navigator.clipboard.writeText(textToCopy);
  } else {
    // text area method
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    // make the textarea out of viewport
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    return new Promise((res, rej) => {
      // here the magic happens
      document.execCommand("copy") ? res(null) : rej();
      textArea.remove();
    });
  }
}
export const truncateAddress = (address: string | undefined) => {
  if (address !== undefined && ethers.utils.isAddress(address)) {
    return `${address.slice(0, 7)}...${address.slice(address.length - 5)}`;
  }
  return "";
};
